import { Star, Flower2, Sun, Play } from "lucide-react";
import { ABOUT_TILES } from "../mock";

function Tile({ t, className = "", eager }) {
  return (
    <div
      className={`rounded-2xl overflow-hidden ${t.color} ${className} group`}
    >
      <img
        src={t.image}
        alt="work"
        loading={eager ? "eager" : "lazy"}
        className="w-full h-full object-cover grayscale mix-blend-multiply opacity-90 group-hover:grayscale-0 group-hover:mix-blend-normal group-hover:opacity-100 transition-all duration-700"
      />
    </div>
  );
}

export default function AboutCollage() {
  return (
    <div className="relative pt-8 lg:pt-0" data-testid="about-collage">
      <Flower2
        className="absolute -top-6 left-2 text-[#F97316] bounce-soft"
        size={26}
      />
      <Sun className="absolute top-1/2 -left-3 text-[#F59E0B] spin-slow hidden md:block" size={22} />
      <Star className="absolute -bottom-3 right-1/3 text-[#8B5CF6] fill-[#8B5CF6] float-x" size={16} />

      <div className="flex gap-3 md:gap-4">
        <div className="flex-1 flex flex-col gap-3 md:gap-4 pt-10">
          <Tile t={ABOUT_TILES.left[0]} className="relative aspect-[4/5]" />
          <Tile t={ABOUT_TILES.left[1]} className="relative aspect-[4/5]" />
        </div>

        <div className="flex-[1.15] relative min-h-[360px]">
          <Star
            className="absolute -top-4 left-1/2 -translate-x-1/2 text-black fill-black z-10 bounce-soft"
            size={28}
          />
          <Tile t={ABOUT_TILES.center} className="absolute inset-0" eager />
          <span className="absolute bottom-3 left-3 text-[11px] font-semibold bg-white px-2.5 py-1 rounded-full whitespace-nowrap">
            Prince · Founder
          </span>
        </div>

        <div className="flex-1 flex flex-col gap-3 md:gap-4 pb-10">
          <Tile t={ABOUT_TILES.right[0]} className="relative aspect-[4/5]" />
          <Tile t={ABOUT_TILES.right[1]} className="relative aspect-[4/5]" />
          <p className="text-xs font-bold tracking-wider text-right pr-1">#2025</p>
        </div>
      </div>

      <a
        href="#work"
        data-testid="about-explore-badge"
        className="absolute -top-8 -right-2 md:-right-8 w-24 h-24 md:w-28 md:h-28 rounded-full bg-white border border-black/10 shadow-md flex items-center justify-center hover:scale-105 transition-transform"
      >
        <svg viewBox="0 0 100 100" className="absolute inset-0 spin-slow p-1">
          <defs>
            <path
              id="aboutCircle"
              d="M 50, 50 m -38, 0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0"
            />
          </defs>
          <text className="fill-black text-[9px] tracking-[0.2em] font-semibold">
            <textPath href="#aboutCircle">EXPLORE MORE · EXPLORE MORE ·</textPath>
          </text>
        </svg>
        <span className="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center">
          <Play size={12} fill="currentColor" className="ml-0.5" />
        </span>
      </a>
    </div>
  );
}
